<template>
    <div class="content-wrapper remove_table_shadow">

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <div
            class="card card-with-search border-0 card-with-shadow d-none"
            v-for="(item, index) in packages"
            :key="index"
        >
            <div class="card-header d-flexjustify-content-between align-items-centerp-primarybg-transparent">
                <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
            </div>
            <div class="card-body">
                <div class="text-justify" v-for="inc in item.include" :key="inc">
                    {{ inc }}
                </div>
            </div>

            <app-button
                :label="$t('purchase_now')"
                class-name="btn-success mr-2"
                :is-disabled="false"
                @submit="btnSubmit(item.id)"
            />
        </div>

        <packages-addmodal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        />
        <certificate-forms-view-modal
            v-if="isFormModalActive"
            :companyId="company_id"
            :certificateId="certificate_id"
            @close-modal="closeFormModal"
            />
    </div>
</template>

<script>
import * as actions from '@/app/Config/ApiUrl';
import CoreLibrary from '@/core/helpers/CoreLibrary';
import { TableHelpers } from '@Views/Demo/Tables/mixins/TableHelpers';
import { axiosGet, axiosPost } from '@/app/Helpers/AxiosHelper';
// import CustomDataTableProp from '@/core/components/datatable/props/CustomDataTableProp'

export default {
    extends: CoreLibrary,
    name: 'DatatableWithFilter',
    mixins: [TableHelpers],
    data() {
        return {
            isFormModalActive: false,
            packages: {},
            certificate_id: 0,
            company_id: 0,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'advance-table-certificate-applied',
            rowData: {},
            input: {},
            options: {
                name: 'AdvanceTableCertificateApplied',
                url: actions.BUYER_CERTIFICATE_APPLIED,
                dataSource: {},
                showHeader: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        modifier: (value, row) => {
                            return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value)}</a>`;
                        }
                    },
                  {
                    title: this.$t('Expiry'),
                    type: 'custom-html',
                    key: 'expire_day',
                    modifier: (value) => {
                      return `<span>${this.$t(value)} Days</span>`;
                    }
                  },
                    {
                        title: this.$t('Description'),
                        type: 'custom-html',
                        key: 'description',
                        modifier: (value) => {
                            return `<span>${this.$t(value)}</span>`;
                        }
                    },
                    {
                        title: this.$t("status"),
                        type: "custom-html",
                        key: "pivot",
                        isVisible: true,
                        modifier: (value) => {
                        let ClassName = "warning";

                        if (value.status === "accepted") ClassName = `success`;
                        else if (value.status === "rejected") ClassName = `danger`;

                        return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                            value.status
                        )}</span>`;
                        },
                    },
                ],
                actions: [
                    // {
                    //   title: this.$t("edit"),
                    //   icon: "edit",
                    //   type: "none",
                    //   component: "app-add-modal",
                    //   modalId: "demo-add-edit-Modal",
                    // },
                    // {
                    //   title: this.$t("delete"),
                    //   icon: "trash",
                    //   type: "none",
                    //   component: "app-confirmation-modal",
                    //   modalId: "demo-delete",
                    // },
                    {
                        title: this.$t('view'),
                        icon: 'eye',
                        type: 'none',
                        // component: 'app-add-modal',
                        // modalId: 'demo-add-edit-Modal'
                    }
                ],
                filters: [
                    // {
                    //     "title": this.$t('date'),
                    //     "type": "range-picker",
                    //     "key": "date",
                    //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    // },
                    // {
                    //     "title": this.$t('age'),
                    //     "type": "range-filter",
                    //     "key": "age-range",
                    //     "maxTitle": this.$t('max_age'),
                    //     "minTitle": this.$t('min_age'),
                    //     "sign": ""
                    // },
                    // {
                    //     "title": this.$t('status'),
                    //     "type": "checkbox",
                    //     "key": "status",
                    //     "option": [
                    //         {id: 'active', value: 'Active'},
                    //         {id: 'inactive', value: 'Inactive'},
                    //         {id: 'invited', value: 'Invited'},
                    //     ],
                    // },
                    // {
                    //     "title": this.$t('gender'),
                    //     "type": "radio",
                    //     "key": "filter-with-gender",
                    //     "option": [
                    //         {id: 'male', value: 'Male'},
                    //         {id: 'female', value: 'Female'},
                    //         {id: 'other', value: 'Other'},
                    //     ],
                    //     "header": {
                    //         "title": this.$t('want_to_filter_your_list'),
                    //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
                    //     },
                    // },
                    // {
                    //     "title": this.$t('search_and_select'),
                    //     "type": "drop-down-filter",
                    //     "key": "search select",
                    //     "option": [],
                    // }
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: 'pagination',
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: 'dropdown'
            }
        };
    },
    created() {
         this.options.columns = [...this.options.columns, this.actionObj];
        // this.searchAndSelectFilterOptions();
        // this.getDataFromServerToCustomize();
    },
    mounted() {
        // this.getPackages();
        setTimeout(() => {
            $('.remove_table_shadow .h-100 .datatable .table-responsive ').removeClass('shadow');
        }, 1000);
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        closeFormModal() {
            $("#demo-add-edit-Modal").modal("hide");
            this.isFormModalActive = false;
            this.searchAndSelectFilterOptions();
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            $('#demo-add-edit-Modal').modal('hide');
            this.isAddEditModalActive = false;
            // this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('view')) {
                this.certificate_id = this.rowData.id;
                this.company_id = this.rowData.pivot.company_id;
                this.isFormModalActive = true;
                // location.replace('/buyer/certificate/applied/detail/' + this.rowData.pivot.id);
            }
        },
      view(rowData) {
           this.certificate_id = rowData.id;
           this.company_id = rowData.pivot.company_id;
           this.isFormModalActive = true;
        },
        myFunction(data){
            let doc = document.getElementById(data.id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(data);
            }); 
            }
        },
        buyerCertificate(id) {
            this.input.id = id;
            axiosPost(actions.BUYER_CERTIFICATE_STORE, this.input)
                .then((res) => {
                    this.$toastr.s(res.data);
                    location.reload();
                })
                .catch((error) => {
                    this.$toastr.s(error);
                });
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
            this.deleteLoader = true;
            axiosGet(url)
                .then((response) => {
                    this.deleteLoader = false;
                    $('#demo-delete').modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({ error }) => {
                    // Trigger after error
                })
                .finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
                let name = this.options.filters.find((element) => element.title === this.$t('search_and_select'));

                name.option = response.data.map((name) => {
                    return {
                        id: name.name,
                        value: name.name
                    };
                });
            });
        },
        btnSubmit(id) {
            location.replace('/admin/stripePay/' + id);
        },
        // getDataFromServerToCustomize() {
        //     axiosGet(actions.BUYER_CERTIFICATE_APPLIED)
        //         .then((response) => {
        //             response.data.data = response.data.data[0].task;
        //             this.options.columns = [...this.options.columns, this.actionObj];
        //             this.options.dataSource = response;
        //             this.$hub.$emit('reload-' + this.tableId);
        //         })
        //         .catch(({ error }) => {
        //             console.error(error);
        //         });
        // }
    }
};
</script>
<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
    box-shadow: none !important;
}
</style>
